import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

export type RejectFinalCostDialogResult = 'back' | boolean | undefined;

@Component({
  selector: 'app-reject-final-cost-modal',
  imports: [MatIcon],
  templateUrl: './reject-final-cost-modal.component.html',
  styleUrl: './reject-final-cost-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RejectFinalCostModalComponent {
  private readonly dialogRef = inject(
    MatDialogRef<unknown, RejectFinalCostDialogResult>,
  );

  onBack(): void {
    this.dialogRef.close('back');
  }
}
